import { Columns } from 'components/shared/Columns';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const isometricIllustrations = [
    <p key="1">
        Our illustration style is bold and dimensional. It follows an isometric perspective and was
        created to capture the essence of the Free Market Health brand and is used across a range of
        marketing and application communications.
    </p>,
    <img
        className="sds_image__container"
        key="2"
        width="100%"
        src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-ecosystem.svg"
        alt="Illustration of Free Market Health ecosystem"
        loading="lazy"
    />,
    <Columns
        key="3"
        columns={Columns.ColumnNumber.TWOLOCK}
        content={
            <>
                <img
                    className="sds_image__container"
                    src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-pharmacy.svg"
                    alt="Illustration of pharmacy"
                    loading="lazy"
                />
                <img
                    className="sds_image__container"
                    src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-patient.svg"
                    alt="Illustration of patient"
                    loading="lazy"
                />
            </>
        }
    />,
];

const flagIconFrame = [
    <p key="4">
        In certain scenarios, a customized Flag Icon is used as a key graphic. This mark has been
        modified with a heavier weight and a narrower spacing to have a stronger visual impact and
        also accommodate a masked image. An illustration or photograph can be masked inside the Flag
        Icon. Do not place a face inside the Flag Icon as it could create awkward image crops.
    </p>,
    <img
        className="sds_image__container"
        key="5"
        width="100%"
        src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-flag-icon.png"
        alt="Flag Icon with masked illustration"
        loading="lazy"
    />,
];

const underlineIllustration = [
    <p key="6">
        In certain scenarios, a customized hand-drawn underline can be added to a word or phrase
        within headlines and hero text to draw emphasis to the message. The underline can be
        animated or used as a static element. Do not use multiple underlines within one section, and
        always use orange as the color of the underline.
    </p>,
    <img
        className="sds_image__container"
        key="7"
        width="100%"
        src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-hand-drawn-underline-1.svg"
        alt="Hand-drawn underline placed under a paragraph"
        loading="lazy"
    />,
    <img
        className="sds_image__container"
        key="8"
        width="100%"
        src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-hand-drawn-underline-2.svg"
        alt="Hand-drawn underline placed under a word"
        loading="lazy"
    />,
];

const screenshots = [
    <p key="9">
        These are examples of simplified screenshots for marketing purposes. For in application
        feature announcements, please use actual application screenshots. Details are redacted from
        these views to put the focus on relevant features and limit frequent updates. Use only
        approved colors and stay as close to the software layout as possible.
    </p>,
    <Columns
        key="10"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <img
                    className="sds_image__container"
                    src="https://sseasacdn.blob.core.windows.net/strata-website/screenshot-live-referral.png"
                    alt="Application screenshot of the Live Referrals page"
                    loading="lazy"
                />
                <img
                    className="sds_image__container"
                    src="https://sseasacdn.blob.core.windows.net/strata-website/screenshot-referral.png"
                    alt="Application screenshot of the Referral Details page"
                    loading="lazy"
                />
                <img
                    className="sds_image__container"
                    src="https://sseasacdn.blob.core.windows.net/strata-website/screenshot-timeline.png"
                    alt="Application screenshot of the Referral Timeline"
                    loading="lazy"
                />
                <img
                    className="sds_image__container"
                    src="https://sseasacdn.blob.core.windows.net/strata-website/screenshot-performance.png"
                    alt="Application screenshot of the Referral Performance page"
                    loading="lazy"
                />
            </>
        }
    />,
];

const icons = [
    <p key="11">
        Free Market Health icons are bold and geometric. They are created using an 80px by 80px grid
        and are designed to capture the essence of the Free Market Health brand. Icons are used
        across marketing materials and within the applications. They provide conceptual clarity and
        visual interest in simplistic shapes and forms. Icons can be colored using any primary or
        secondary colors. Below are a few examples of the icons available.
    </p>,
    <img
        className="sds_image__container"
        key="12"
        width="100%"
        src="https://sseasacdn.blob.core.windows.net/strata-website/illustration-icons.svg"
        alt="A few examples of available FMH icons"
        loading="lazy"
    />,
];

export const Illustration = () => (
    <div>
        <Page
            pageTitle="Illustration"
            pageDescription="This page outlines Free Market Health's illustration style and icon set. Consistent use of illustration will help establish a cohesive visual style."
            pageContent={
                <>
                    <Section
                        title="Isometric Illustrations"
                        contentArray={isometricIllustrations}
                    />
                    <Section title="Flag Icon as a Frame" contentArray={flagIconFrame} />
                    <Section title="Hand-drawn Underline" contentArray={underlineIllustration} />
                    <Section title="Screenshots" contentArray={screenshots} />
                    <Section title="Icons" contentArray={icons} />
                </>
            }
        />
    </div>
);
